import React from 'react';

import { PanelGroup as RPPanelGroup, PanelGroupProps as RPPanelGroupProps } from 'react-resizable-panels';

import cn from '~/utils/cn';

export interface ResizeablePanelsProps extends Omit<RPPanelGroupProps, 'className' | 'direction'> {
  children: React.ReactNode;
  className?: string;
}

export const ResizeablePanels: React.FC<ResizeablePanelsProps> = ({ children, className = '', ...rest }) => {
  return (
    <RPPanelGroup className={cn('flex h-full w-full', className)} {...rest} direction="horizontal">
      {children}
    </RPPanelGroup>
  );
};

export default ResizeablePanels;
